import type { ChangeEvent, FunctionComponent, ReactNode } from 'react';

import LabeledCheckbox from './LabeledCheckbox';
import TextInput from './TextInput';

import styles from './LabeledCheckboxWithInput.module.less';

type LabeledCheckboxWithInputProps = {
  label: ReactNode;
  isChecked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  inputAriaLabel?: string;
  inputPlaceholder?: string;
  inputSize?: 'small' | 'medium' | 'large';
  isDisabled?: boolean;
};

/**
 * A checkbox whose label morphs into an inline text input when the checkbox
 * is checked. Use for the "Other: ___" pattern alongside `LabeledCheckbox`.
 */
const LabeledCheckboxWithInput: FunctionComponent<LabeledCheckboxWithInputProps> = ({
  label,
  isChecked,
  onChange,
  inputValue,
  onInputChange,
  inputAriaLabel = 'Open response',
  inputPlaceholder,
  inputSize = 'medium',
  isDisabled,
}) => (
  <LabeledCheckbox
    isChecked={isChecked}
    onChange={onChange}
    isDisabled={isDisabled}
    label={
      isChecked ? (
        <span className={styles.openLabel}>
          <span className={styles.staticLabel}>{label}:</span>
          <span
            role="presentation"
            className={styles.inputWrapper}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <TextInput
              label={inputAriaLabel}
              value={inputValue}
              onChange={onInputChange}
              placeholder={inputPlaceholder}
              isDisabled={isDisabled}
              size={inputSize}
              variant="underlined"
              autoFocus
            />
          </span>
        </span>
      ) : (
        label
      )
    }
  />
);

export default LabeledCheckboxWithInput;
